import React from 'react'
import { ProductDetail } from '../../components';
const ProductDetailPage = () => (
  <div className="container-fluid h-100 w-100">
    <div className="row h-100">
        <ProductDetail />
    </div>
  </div>
);

export default ProductDetailPage;
